import React from 'react'
import { FormattedMessage } from 'react-intl'
import { FormattedHeartRate } from 'shared/units'
import { CharField } from 'components/forms'
import styles from './_workoutForm.css'

export default function HeartRate () {
  return (
    <CharField
      bold
      short
      type='number'
      min='0'
      step='1'
      name='heartrate'
      inputContainerClassName={styles.shortInput}
      labelComponent={(
        <FormattedMessage
          id='workouts.create.heartrate'
          defaultMessage='Avg. Heart Rate'
        />
      )}
      afterComponent={(
        <span className={styles.fieldUnit}>
          <FormattedHeartRate id='workouts.create.energy_unit' />
        </span>
      )}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/workouts/WorkoutForm/HeartRate.jsx